@if (message) {
  <div class="error" [class.full-width]="fullWidth">
    <i class="material-icons error-icon">error</i>
    <span>{{ message }}</span>
  </div>
}
